"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xxlBreakpoint = exports.xlBreakpoint = exports.websiteDomainConnectIconColor = exports.vhTextLetterExtended = exports.vhSectionTitle = exports.v4aWelcomePopupShadow = exports.v4aRecommendationShadowDefault = exports.v4aOffbrandTextMediumDark = exports.v4aOffbrandMediumGray = exports.v4aOffbrandBorderBlue = exports.v4aOffbrandBgLightGray = exports.v4aOffbrandBgDark = exports.v4aMiniMyaShadowHover = exports.v4aMiniMyaShadowDefault = exports.v4aDefaultHoverTransition = exports.v4aDefaultBorderRadius = exports.tileBorderColor = exports.tabletBreakpoint = exports.subpageButtonBorderColor = exports.skeletonTextRow = exports.skeletonAnimatedBg = exports.productTileButtonColor = exports.plTabletBreakpoint = exports.nbaItemColorRandomizer = exports.nbaItemAnimatedBg = exports.mobileBreakpoint = exports.largeBreakpoint = exports.h100 = exports.godaddyProductBase = exports.godaddyPastelTeal = exports.godaddyMidrangeTeal = exports.godaddyFaintGray = exports.godaddyDefaultText = exports.godaddyBaseTeal = exports.gdSherpa = exports.flexibleExpandingColumn = exports.bodyContentMaxWidth = exports.accountTabsCardTextBg = void 0;
var _core = require("@linaria/core");
var _intents = _interopRequireDefault(require("@ux/intents"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const intents = new _intents.default();
const bodyContentMaxWidth = '1140px';
exports.bodyContentMaxWidth = bodyContentMaxWidth;
const mobileBreakpoint = '520px';
exports.mobileBreakpoint = mobileBreakpoint;
const tabletBreakpoint = '768px';
exports.tabletBreakpoint = tabletBreakpoint;
const largeBreakpoint = '992px';
exports.largeBreakpoint = largeBreakpoint;
const xlBreakpoint = '1200px';
exports.xlBreakpoint = xlBreakpoint;
const xxlBreakpoint = '1400px';
exports.xxlBreakpoint = xxlBreakpoint;
const plTabletBreakpoint = '1366px';
exports.plTabletBreakpoint = plTabletBreakpoint;
const godaddyDefaultText = '#111111';
exports.godaddyDefaultText = godaddyDefaultText;
const godaddyFaintGray = '#f5f7f8';
exports.godaddyFaintGray = godaddyFaintGray;
const godaddyProductBase = '#d4dbe0';
exports.godaddyProductBase = godaddyProductBase;
const godaddyBaseTeal = '#00A4A6';
exports.godaddyBaseTeal = godaddyBaseTeal;
const godaddyMidrangeTeal = '#09757A';
exports.godaddyMidrangeTeal = godaddyMidrangeTeal;
const godaddyPastelTeal = '#D8EFEF';
exports.godaddyPastelTeal = godaddyPastelTeal;
const v4aOffbrandBgDark = '#24262C';
exports.v4aOffbrandBgDark = v4aOffbrandBgDark;
const v4aOffbrandBgLightGray = '#FBFDFC';
exports.v4aOffbrandBgLightGray = v4aOffbrandBgLightGray;
const v4aOffbrandTextMediumDark = '#444';
exports.v4aOffbrandTextMediumDark = v4aOffbrandTextMediumDark;
const v4aOffbrandBorderBlue = '#0D54C4';
exports.v4aOffbrandBorderBlue = v4aOffbrandBorderBlue;
const v4aOffbrandMediumGray = '#5E5E5E';
exports.v4aOffbrandMediumGray = v4aOffbrandMediumGray;
const v4aWelcomePopupShadow = '0px 6px 16px rgba(0, 0, 0, 0.15)';
exports.v4aWelcomePopupShadow = v4aWelcomePopupShadow;
const v4aDefaultHoverTransition = 'box-shadow 300ms ease-out, border 120ms linear';
exports.v4aDefaultHoverTransition = v4aDefaultHoverTransition;
const v4aDefaultBorderRadius = '8px';
exports.v4aDefaultBorderRadius = v4aDefaultBorderRadius;
const v4aMiniMyaShadowDefault = '0px 2px 16px rgba(0, 0, 0, 0.08)';
exports.v4aMiniMyaShadowDefault = v4aMiniMyaShadowDefault;
const v4aMiniMyaShadowHover = '0px 4px 24px rgba(0, 66, 73, 0.24)';
exports.v4aMiniMyaShadowHover = v4aMiniMyaShadowHover;
const v4aRecommendationShadowDefault = '0px 0px 12px rgba(17, 17, 17, 0.07), 0px 4px 4px rgba(17, 17, 17, 0.1), 0px 6px 8px rgba(17, 17, 17, 0.07)';
exports.v4aRecommendationShadowDefault = v4aRecommendationShadowDefault;
const tileBorderColor = '#D6D6D6';
exports.tileBorderColor = tileBorderColor;
const subpageButtonBorderColor = '#8995A9';
exports.subpageButtonBorderColor = subpageButtonBorderColor;
const productTileButtonColor = '#444444';
exports.productTileButtonColor = productTileButtonColor;
const websiteDomainConnectIconColor = '#767676';
exports.websiteDomainConnectIconColor = websiteDomainConnectIconColor;
const vhTextLetterExtended = "v1fv1zbu";
exports.vhTextLetterExtended = vhTextLetterExtended;
const h100 = "hcdgsjv";

// NOTE(cvogt): these style declarations are copy + pasted from the InSight™
// section titles for consistency. To learn more about those styles, inspect
// the .DiscoverContainer-section-text styles.
exports.h100 = h100;
const vhSectionTitle = "v13thxpr";

// Expand column to take up full page
exports.vhSectionTitle = vhSectionTitle;
const flexibleExpandingColumn = {
  display: 'flex',
  flexDirection: 'column',
  flex: '1'
};

// NOTE(cvogt): the following styes create the reusable skeleton loaders for
// Venture Home.
exports.flexibleExpandingColumn = flexibleExpandingColumn;
const skeletonAnimatedBg = "sefyol2";
exports.skeletonAnimatedBg = skeletonAnimatedBg;
const accountTabsCardTextBg = "a11unagu";
exports.accountTabsCardTextBg = accountTabsCardTextBg;
const nbaItemAnimatedBg = "n7tmd3u";

// 24px is the default text line-height
exports.nbaItemAnimatedBg = nbaItemAnimatedBg;
const skeletonTextRow = "s2eli5r";

// NOTE(cvogt): this value was pulled from the company website (www.godaddy.com)
exports.skeletonTextRow = skeletonTextRow;
const gdSherpa = 'gdsherpa, Helvetica, Arial, sans-serif';
exports.gdSherpa = gdSherpa;
const nbaItemColors = ['#DDEAF8', '#D8EFEF', '#E9E4F2', intents.ux.navigatePrimary.foregroundColor];
const nbaItemColorRandomizer = () => nbaItemColors[Math.floor(Math.random() * nbaItemColors.length)];
exports.nbaItemColorRandomizer = nbaItemColorRandomizer;